import { Schedule } from '@/features/accounts/types';
import DateInterestSummary from '@/features/accounts/schedule/components/DateInterestSummary';

interface Props {
  schedule: Schedule | null;
}

export default function DateRangeCell({ schedule }: Props) {
  if (!schedule) return null;
  return <DateInterestSummary interest={schedule.date_interest} />;
}
